<template>
  <div class="newdirect-wrap">
    <ul class="modal-form">
      <el-form :model="formData" :disabled="!!alreadyCampaignId" :rules="rules" ref="directFormRef">
        <li class="form-item">
          <span class="form-label">地区组名称：</span>
          <el-form-item prop="geoName">
            <div class="form-value">
              <el-input type="text" placeholder="请填写" maxlength="20" show-word-limit style="width: 380px" v-model="formData.geoName"></el-input>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span class="form-label">地区：</span>
          <el-form-item prop="regionType">
            <div class="form-value">
              <el-radio-group v-model="formData.regionType">
                <el-radio label="UNLIMITED">不限</el-radio>
                <el-radio label="ASSIGN">指定</el-radio>
              </el-radio-group>
              <div class="custom-wrap" v-show="formData.regionType === 'ASSIGN'">
                <list-check @selectChange="selectChange" ref="customFlowRef"></list-check>
              </div>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span class="form-label">语言：</span>
          <el-form-item prop="languages">
            <div class="form-value">
              <el-radio-group v-model="formData.languageType">
                <el-radio label="UNLIMITED_LAN">不限</el-radio>
                <el-radio label="ASSIGN_LAN">指定</el-radio>
              </el-radio-group>
              <el-select
                v-if="formData.languageType === 'ASSIGN_LAN'"
                v-model="formData.languages"
                style="width: 500px; display: block"
                multiple
                filterable
                collapse-tags
                placeholder="请选择语言"
              >
                <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span class="form-label">目标：</span>
          <el-form-item prop="positiveGeoTargetType">
            <div class="form-value">
              <el-radio-group v-model="formData.positiveGeoTargetType">
                <el-radio label="PRESENCE_OR_INTEREST" class="radio-item">位于您指定的地理位置或对其表现出兴趣的用户(推荐)</el-radio>
                <el-radio label="PRESENCE" class="radio-item">位于定位到的地理位置的用户或定期访问该地理位置的用户</el-radio>
                <!-- <el-radio label="SEARCH_INTEREST" class="radio-item">搜索您指定的地理位置的用户</el-radio> -->
              </el-radio-group>
            </div>
          </el-form-item>
        </li>
        <li class="form-item">
          <span class="form-label">排除：</span>
          <el-form-item prop="negativeGeoTargetType">
            <div class="form-value">
              <el-radio-group v-model="formData.negativeGeoTargetType">
                <el-radio label="PRESENCE" class="radio-item">位于您排除的地理位置的用户 (推荐) </el-radio>
                <el-radio label="PRESENCE_OR_INTEREST" class="radio-item">位于您排除的地理位置或对其表现出兴趣的用户</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </li>
      </el-form>
    </ul>
    <div class="button-wrap" style="text-align: right">
      <el-button type="primary" :disabled="!!alreadyCampaignId" @click="saveRegionPkg" :loading="saveLoading">保存到地区组</el-button>
    </div>
  </div>
</template>

<script>
import { getGoogleLanguageList, saveAssetGroup } from "@/api/promotion-google.js";
import ListCheck from "./listCheck.vue";
import { mapState } from "vuex";
export default {
  components: {
    ListCheck,
  },
  data() {
    return {
      formData: {
        geoName: "",
        geo: {
          exclude: [],
          include: [],
        },
        regionType: "UNLIMITED",
        languageType: "UNLIMITED_LAN",
        languages: [],
        positiveGeoTargetType: "PRESENCE_OR_INTEREST",
        negativeGeoTargetType: "PRESENCE",
      },
      rules: {
        geoName: [
          {
            required: true,
            message: "请输入地区组名称",
            trigger: ["blur", "change"],
          },
        ],
        languages: [
          {
            validator: (rule, value, callback) => {
              if (value?.length === 0 && this.formData.languageType === "ASSIGN_LAN") {
                callback(new Error("请选择语言"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      languageList: [],
      transferList: {
        behaviorList: [],
        interestList: [],
      },
      saveLoading: false,
    };
  },
  mounted() {
    this.getOptionList();
  },
  methods: {
    getOptionList() {
      getGoogleLanguageList().then((res) => {
        this.languageList = res.data;
      });
    },
    formatData() {
      let res = JSON.parse(JSON.stringify(this.formData));
      const { regionType, languages, languageType } = this.formData;
      if (regionType === "UNLIMITED") {
        res.geo = {
          exclude: [],
          include: [],
        };
      }
      res.languages = [];
      languages.map((item) => {
        const findObj = this.languageList.find((child) => child.id == item);
        res.languages.push(findObj);
      });
      if (languageType === "UNLIMITED_LAN") {
        res.languages = [];
      }
      return res;
    },
    saveRegionPkg() {
      if (this.formData.geoName === "") {
        this.$alert("地区组名称必填", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let parmas = this.formatData();
      this.saveLoading = true;
      saveAssetGroup({
        advertiserId: this.adCount,
        assetType: 1,
        data: JSON.stringify(parmas),
        groupName: this.formData.geoName,
        platType: 5,
      }).then((res) => {
        this.saveLoading = false;
        if (res.code === "0000") {
          this.$emit("closeDrawer");
          this.$message({
            message: "地区组新建成功",
            type: "success",
          });
        }
      });
    },
    checkData() {
      this.$refs.directFormRef.validate(() => {});
    },
    fillData(dataItem) {
      this.formData = dataItem;
      const { languages, geo, geoName } = dataItem;
      this.formData.languageType = languages?.length > 0 ? "ASSIGN_LAN" : "UNLIMITED_LAN";
      this.formData.regionType = geo && (geo.exclude?.length > 0 || geo.include?.length > 0) ? "ASSIGN" : "UNLIMITED";
      if (this.formData.regionType === "ASSIGN") {
        this.$refs.customFlowRef.selectItem.includeList = geo.include;
        this.$refs.customFlowRef.selectItem.excludeList = geo.exclude;
      }
      this.formData.languages = languages.map((item) => item.id);
      this.formData.geoName = geoName || "新建地区组";
    },
    selectChange() {
      let exData = this.$refs.customFlowRef?.selectItem;
      this.formData.geo.exclude = exData.excludeList;
      this.formData.geo.include = exData.includeList;
    },
    clearCustomCountryList() {
      if (this.$refs.customFlowRef) {
        this.$refs.customFlowRef.clearAllList();
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
    }),
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.newdirect-wrap {
  box-sizing: border-box;
  padding-top: 10px;
  .modal-form {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 114px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        padding-top: 13px;
        &.require::before {
          content: "*";
          display: inline-block;
          color: red;
          margin-right: 4px;
        }
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        .custom-wrap {
          margin-top: 10px;
        }
        .radio-item {
          display: block;
          margin-top: 12px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
